import React from "react"
import { useSelector } from "react-redux"
import { selectUserAttributes, selectUserGroups } from "lib/store/services/auth/selectors"
import { UserError } from "./UserError"
import { GreetingDate, SubGreeting, WelcomeGreeting } from "./Home.styled"
import { ProductBoard } from "./Info"
import { WhatsNewButton } from "components/Ui/WhatsNewButton"
import dayjs from "dayjs"

export function Home() {
  const userAttributes = useSelector(selectUserAttributes)
  const userGroups = useSelector(selectUserGroups)

  if (!userGroups) return <UserError />
  return (
    <>
      <WelcomeGreeting>
        <b>
          Hello
          {userAttributes?.given_name && (
            <>
              , <span>{userAttributes.given_name}</span>
            </>
          )}
        </b>
        <SubGreeting>Welcome back</SubGreeting>
        <GreetingDate>
          {" "}
          {`It's ${dayjs().format("dddd")}, ${dayjs().format("YYYY-MM-DD")}`}
        </GreetingDate>
      </WelcomeGreeting>
      <ProductBoard />
      <WhatsNewButton />
    </>
  )
}
